import React, { useEffect, useRef, useState } from 'react'
import AILogo from '@/static/image/ai-learn/AI-logo.svg'
import zhCN from 'antd/lib/locale/zh_CN'
import AICss from './ai-learn.module.less'
import Cookies from 'js-cookie'
import Qs from 'qs';


import { BACKEND_API_URL } from '../../constants/constants'
import { Layout, message, InputRef, ConfigProvider, Col, Row, Pagination, Input, Alert,Button, Popover, Modal, Tabs, Empty, Table, Drawer,Space} from 'antd'
import { DeleteOutlined, SwapOutlined ,ReadOutlined, MessageOutlined, RightOutlined , EditOutlined, EllipsisOutlined,LikeOutlined, DislikeOutlined , PushpinOutlined, ReloadOutlined, PauseCircleOutlined, CopyOutlined,SendOutlined, PlusOutlined, InfoCircleOutlined} from '@ant-design/icons'

import {checkUserLogin} from "../common/user-center/user-info";
import { getCollegeId } from '../../component/modal/teacher-authenticate/teacher-authenticate'

import exerciseStyles from '@/pages/exercise/exercise.module.less'

import { sendHttpPostRequest } from '../../api/http-request'

import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import remarkMath from 'remark-math'
import rehypeKatex from 'rehype-katex'
import rehypeRaw from 'rehype-raw'
import 'katex/dist/katex.min.css'
import gfm from 'remark-gfm'
import rehypeHighlight from 'rehype-highlight'

import MonacoEditor from 'react-monaco-editor'
import 'codemirror/lib/codemirror.css'
import 'codemirror/theme/material-darker.css' // dark 模式
import 'codemirror/theme/xq-light.css' // light 模式

import 'codemirror/mode/python/python' // 代码提示
import 'codemirror/addon/hint/show-hint.css'
import 'codemirror/addon/hint/show-hint'

// import 'codemirror/addon/hint/python-hint';
import 'codemirror/addon/selection/active-line' // 选中行高亮
import 'codemirror/addon/selection/selection-pointer'
import 'codemirror/addon/selection/mark-selection'
import 'codemirror/addon/search/matchesonscrollbar.css'
import 'codemirror/addon/search/searchcursor'
import 'codemirror/addon/search/match-highlighter'

import 'codemirror/addon/comment/comment' // 支持ctrl(cmd) + / 快速(取消)注释
import 'codemirror/keymap/sublime' // sublime关键字

import 'codemirror/addon/edit/closebrackets' // 封闭括号
import 'codemirror/addon/edit/matchbrackets' // 匹配括号
import courseMainStyles from '../course/course-main.module.less'
import PublicTipModal from '@/component/PublicTipModal/PublicTipModal'
import Draggable from 'react-draggable'


import exerciseCardStyles from '../exercise/exercise-card-white.module.less'

import idataCourseTableWhiteStyles from '../common/global-styles/idatacourse-table.module.less'
import ReactDOM from 'react-dom'
const { TabPane } = Tabs

// 用于测试 引用悬浮框 
const test_citation_text = "Boosting类集成模型的目标是学习一个加性模型（AdditiveModel）  $$F(x)=\\sum_{m=1}^{M}\\alpha_{m}f_{m}(x),$$  其中$f_{m}(x)$为弱分类器（WeakClassifer），或基分类器（BaseClassifier）， $\\alpha_{m}$ 为弱分类器的集成权重 $\\mathbf{\\delta}_{,F(x)}$ 称为强分类器（StrongClassifier）.  Boosting类方法的关键是如何训练每个弱分类器$f_{m}(x)$及其权重 $\\alpha_{m}$ 为了提高集成的效果，应当尽量使得每个弱分类器的差异尽可能大.一种有效的算法是采用选代的方法来学习每个弱分类器，即按照一定的顺序依次训练每个弱分类器.假设已经训练了$m$个弱分类器，在训练第第$m+1$个弱分类器时，增加已有弱分类器分错样本的权重，使得第$m+1$个弱分类器“更关注”于已有弱分类器  分错的样本，这样增加每个弱分类器的差异，最终提升集成分类器的准确率.这种方法称为AdaBoost（AdaptiveBoosting）算法  AdaBoost算法是一种迭代式的训练算法，通过改变数据分布来提高弱分类器的差异.在每一轮训练中，增加分错样本的权重，减少分对样本的权重，从而得到一个新的数据分布  以二分类为例，弱分类器$f_{m}(x)\\in\\{+1,-1\\},$AdaBoost算法的训练过程如算法10.1所示.最初赋予每个样本同样的权重.在每一轮迭代中，根据当前的样本权重训练一个新的弱分类器.然后根据这个弱分类器的错误率来计算其集成权重，并调整样本权重  "

const editorOptions = {
  selectOnLineNumbers: true,
  fontSize: 14,
  minimap: { enabled: false },
  lineDecorationsWidth: 5,
  lineNumbersMinChars: 2,
  quickSuggestions: false,
  // scrollBeyondLastLine: false,  // 控制是否可以滚动到最后一行下面
  // scrollbar: {
  //     verticalScrollbarSize: 0,  // 垂直滚动条宽度
  //     horizontalScrollbarSize: 0,  // 水平滚动条宽度
  // },
  automaticLayout: true, // 拖拽分屏线时自适应宽度
}


interface Props {
  
}


/**
 * AI 问学
 */
export const AILearn: React.FC<Props> = (props) => {
  
  const [isLogin, setIsLogin] = useState(false) //是否登录
  const [indexMode, setIndexMode] = useState(true) // 是否处于初始页状态
  const [collegeId, setCollegeId] = useState(null as any) // 用户所属院校ID

  const [openDrawer, setOpenDrawer] = useState(false);

  const [selectedDialogId, setSelectedDialogId] = useState(null as any) //当前选中对话
  const [selectedDialogPage, setSelectedDialogPage] = useState(1) //当前选中对话所在页码
  const [isConversationEditMode, setIsConversationEditMode] = useState(false)
  const page = useRef(1);  // 记录当前的页数  对话
  const pageSize = useRef(10);  // 记录当前每页展示数量  对话
  const [totalConversationCount, setTotalConversationCount] = useState(0) //对话总数
  const [conversationList, setConversationList] = useState([] as any)
  const inputConversationRef = useRef(null as any);

  const [demoQuestions, setDemoQuestions] = useState([] as any)
  const [streamData, setStreamData] = useState(''); // 存储流式数据
  const lock = false 
  const [questionAnswerList, setQuestionAnswerList] = useState([] as any) //当前对话的问答列表

  const questionCitationMap  = useRef(new Map()) //当前对话所有问答中包含的 引用 列表 {citation_id :"questionid_citationindex", citation_text:'引用文本'}
  const conversationShowMap  = useRef(new Map()) //记录 对话弹出框的显示与隐藏状态

  const [writeQuestion, setWriteQuestion] = useState('')
  const [answerLoading, setAnswerLoading] = useState(false)

    // 用于取消请求的控制器
  const abortControllerRef = useRef(null);
  // 错误信息
  const [error, setError] = useState(null);

  const [requestError, setRequestError] = useState(false)



  const currentSelectedCode = useRef('')  //当前的代码框

  const [myAvatar, setMyAvatar] = useState('static/avatar/default_avatar.png') // 我的头像
  const [myName, setMyName] = useState('') // 我的名字
  

  const [userInfo, setUserInfo] = useState(null as any) //当前用户信息，包括名称头像和角色

  const delConversationID = useRef('') // 要删除的会话ID
  const delConversationName = useRef('') // 要删除的会话名称

  const [deleteConversationModalVis, setDeleteConversationModalVis] = useState(false)

  // 对话 popover 显示变量
  const [conversationPopoverOpen, setConversationPopoverOpen] = useState(false)


  /** 未加机构弹窗变量 */
  const [isNoCollegeModalVisible, setIsNoCollegeModalVisible] = useState(false)
  const draggleNoCollegeRef = useRef<HTMLDivElement | null>(null)
  const [noCollegeBounds, setNoCollegeBounds] = useState({ left: 0, top: 0, bottom: 0, right: 0 })
  const [noCollegeDisabled, setNoCollegeDisabled] = useState(true)

  const onNoCollegeStart = (event: any, uiData: any) => {
    const { clientWidth, clientHeight } = window?.document?.documentElement
    const targetRect = draggleNoCollegeRef?.current?.getBoundingClientRect()
    if (targetRect) {
      setNoCollegeBounds({
        left: -targetRect?.left + uiData?.x,
        right: clientWidth - (targetRect?.right - uiData?.x),
        top: -targetRect?.top + uiData?.y,
        bottom: clientHeight - (targetRect?.bottom - uiData?.y),
      })
    }
  }

  /** 运行代码相关的变量 */

  const [running, setRunning] = useState(false) // 运行中状态
  const [currentStatus, setCurrentStatus] = useState(null as any)
  const [outputs, setOutputs] = useState(null as any) //运行的输出结果
  const [isHtml, setIsHtml] = useState(false)
  const [variables, setVariables] = useState(null as any) //运行的输出变量列表
  const [figures, setFigures] = useState(null as any) // 运行输出的图
  const [activeKey, setActiveKey] = useState('') // 默认激活的tab页

  const resetRunningStatus = ()=> {
    setCurrentStatus(null as any);
    setOutputs(null as any);
    setVariables(null as any);
    setFigures(null as any);
    setActiveKey('outputs');

  }
  const columns: any = [
    {
      title: '变量',
      dataIndex: 'var',
      key: 'var',
      align: 'left',
      width: 60,
      ellipsis:true,
    },
    {
      title: '类型',
      dataIndex: 'type',
      key: 'type',
      align: 'left',
      width: 60,
      ellipsis:true,
    },

    {
      title: '取值',
      dataIndex: 'value',
      key: 'value',
      align: 'left',
      width: 100,
      ellipsis:true,
      render: (text: any) => text
    },
  ]


  const run_code_  = ()=>{

    setCurrentStatus(null as any)
    setRunning(true)
    sendHttpPostRequest(
      'exercise/api/free_python_code_run/',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
        code: currentSelectedCode.current,
      },
      (response: any) => {
        if (response.is_ok) {
          setRunning(false)
          if (response.err_msg == '') {
                setCurrentStatus(true)


                if (response.is_html) { 
                  setOutputs(response.output)
                  setIsHtml(true)
                  setFigures('')
                  const chartId = response.data.js_script.substr( response.js_script.indexOf("document.getElementById('") + 25,32)
                  let checkResult = setInterval(function () {
                    if (document.getElementById(chartId) != null) {
                      try {
                        setTimeout(function () {
                          eval(response.js_script)
                        }, 1000)
                        clearInterval(checkResult)
                      } catch (e) {
                        console.error(e)
                        clearInterval(checkResult)
                        try {
                          setTimeout(function () {
                            eval(response.js_script)
                          }, 1000)
                        } catch (e) {
                          console.error(e)
                        }
                      }
                    }
                  }, 1500)

                } else {
                  let output = response.output.trim()//Left().replaceAll('\n', '<br/>')
                  setOutputs(output)
                  setFigures(response.images)
                } // end html


                setVariables(response.variables)
                setCurrentStatus(true)

                response.images.length > 0 || response.is_html
                  ? setActiveKey('figures')
                  : setActiveKey('outputs')
          } else {
                setOutputs(response.output)
                setVariables(response.variables)
                setCurrentStatus(false)
                setFigures(response.images)
                response.images.length > 0
                  ? setActiveKey('figures')
                  : setActiveKey('outputs')
              } // end err_msg
        }//end is ok
    }
    )

    
  }




  const test_run_output = ()=>{

    return    <div>   
    
    <Row align="top" gutter={[8, 8]}>
        <Col span={24}>
          <div className={exerciseCardStyles.userCode} style={{ height: 400, marginBottom: 10 }} >
            <div style={{ textAlign: 'left' }} >
              <MonacoEditor
                className={exerciseStyles.codeEditor}
                height="400px"
                width="100%"
                language={'python'}
                theme={'vs'} 
                value={currentSelectedCode.current}
                options={editorOptions}
                onChange={(value) => {currentSelectedCode.current = value}}
  
              />
            </div>
          </div>
        </Col>
      </Row>


    <div style={{textAlign:'right'}}><Button onClick={()=>{resetRunningStatus();run_code_()}}  type='primary' style={{borderRadius:20, textShadow:"none", boxShadow:'none'}}>运行</Button></div>
    <div className={exerciseCardStyles.resultCardContainer}>
      <Row
        className={exerciseCardStyles.resultCardHeader}
        align={'middle'}
        justify={'start'}
      >
        {' '}
        <Col className={exerciseCardStyles.titleText}>测试结果</Col>
        <Col>
          {running ? (
            <span
              className="iconfont icon_zhengzaitingzhi"
              style={{ fontSize: '20px', color: '#4285F4' }}
            ></span>
          ) : currentStatus == true ? (
            <span
              className="iconfont icon_goujianchenggong"
              style={{ fontSize: '20px', color: '#07C160' }}
            ></span>
          ) : currentStatus == false ? (
            <span
              className="iconfont icon_tingzhi-20"
              style={{ fontSize: '20px', color: '#FF4B50' }}
            ></span>
          ) : (
            ''
          )}
        </Col>
      </Row>
      <Tabs activeKey={activeKey} onChange={(ac)=>{setActiveKey(ac)}}>
        <TabPane tab="运行结果" key="outputs">
          <div style={{ marginBottom: 10, paddingTop: 0, borderRadius: 5,maxHeight:600, overflow:'auto' }}>
            {outputs ? (
              <ReactMarkdown
                className={exerciseCardStyles.reactmarkdownRunResult}
                remarkPlugins={[gfm, remarkMath]}
                rehypePlugins={[rehypeKatex, rehypeRaw]}
              >
                {isHtml?  outputs: outputs.replaceAll(">","&gt;").replaceAll("<","&lt;").replaceAll("\n","<br/>")}
                
              </ReactMarkdown>
            ) : (
              <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
                description={
                  <span className={exerciseCardStyles.emptyText}>
                    {'暂无运行结果'}
                  </span>
                }
              />
            )}
          </div>
        </TabPane>
        <TabPane tab="变量信息" key="variables">
          <div style={{ marginBottom: 10, paddingTop: 0, borderRadius: 5 }}>
            <div
              className={
                idataCourseTableWhiteStyles.tableWrapper
              }
            >
              <ConfigProvider locale={zhCN}>
                <Table
                  dataSource={variables as any}
                  columns={columns}
                  rowKey={(record) => record.var}
                  pagination={false}
                  //scroll={{ x: 800 }}
                />
              </ConfigProvider>
            </div>
          </div>
        </TabPane>

        <TabPane tab="图像输出" key="figures">
          <div style={{ marginBottom: 10, paddingTop: 0, borderRadius: 5 }}>
            {figures?.length > 0 ? (
              <div
                style={{textAlign:'center'}}
                className={
    idataCourseTableWhiteStyles.tableWrapper
                }
              >
                {figures?.map((figure, index) => {
                  return (
                    <img
                      style={
  
                          { maxWidth: '100%' }
                      }
                      key={index}
                      src={'data:image/jpg;base64,' + figure}
                    />
                  )
                })}
              </div>
            ) : (
              <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
                description={
                  <span className={exerciseCardStyles.emptyText}>
                    {'暂无运行结果'}
                  </span>
                }
              />
            )}
          </div>
        </TabPane>
      </Tabs>
    </div>
  </div>
  }

  function insertAfter(newElement,targetElement){
    let parent = targetElement.parentNode;
    if(parent.lastChild == targetElement){
        parent.appendChild(newElement);
    }else{
        parent.insertBefore(newElement,targetElement.nextsibling);
    }
}


const getSupPopoverContent = (citation_test:string, content:string)=>{
  return     <Popover 
  content={<div> <ReactMarkdown
    remarkPlugins={[
      [remarkGfm, { singleTilde: false }],
      [remarkMath],
    ]}
    rehypePlugins={[rehypeKatex, rehypeRaw]}
  >
    {content}
  </ReactMarkdown> </div>
          } 
  title="" 
  trigger="hover"
  //placement='rightTop'
  overlayClassName={AICss.citationPopover}

 >
    <span>{citation_test}</span>
</Popover>
}
//var div = document.createElement('div');

//infowindow.setContent( div );

// 为页面每个  上标  添加引用 悬浮框
  const addSupCitationPopover = (citationMap)=>{
  let supBlocks = document.querySelectorAll('sup');
  supBlocks.forEach(function(supBlock) {
    const citation_test = supBlock.innerText
    const sup_id = supBlock.getAttribute("id")
    const test_citation_text = citationMap.get(sup_id)
    //console.log(test_citation_text)
    ReactDOM.render(getSupPopoverContent(citation_test, test_citation_text), supBlock) 

  });
}

 // 为页面每个代码框添加 运行  和 复制  按钮
  const addCopyBtnForPres = ()=>{
    let codeBlocks = document.querySelectorAll('pre');
    codeBlocks.forEach(function(codeBlock) {
      let existsRun = codeBlock.parentNode?.querySelectorAll(".runCodeBtn")
      if (existsRun?.length  == 0) {

        let runButton  = document.createElement("button");
        runButton.className = 'runCodeBtn';
        runButton.innerHTML = '运行';
        runButton.onclick = ()=>{setOpenDrawer(true);currentSelectedCode.current = codeBlock.innerText;run_code_() };
  
        let copyButton = document.createElement('text');
        copyButton.className = 'copy';
        copyButton.textContent = '复制代码';
  
  
        // 创建包裹代码块和按钮的容器元素
        let container = document.createElement('div');
        container.className = 'code-container';
  
        container.appendChild(runButton);//添加运行按钮
  
        // 将按钮添加到容器元素内
        container.appendChild(copyButton);
        // 将容器元素插入到代码块之前
        codeBlock.parentNode.insertBefore(container, codeBlock);
  
  
        copyButton.addEventListener('click', function() {
          // 获取代码块的文本内容
          let code = codeBlock.textContent;
          // 创建一个临时的textarea元素，并将代码块的内容设置为其值
          let textarea = document.createElement('textarea');
          textarea.value = code;
  
          // 将textarea元素追加到body中
          document.body.appendChild(textarea);
  
          // 选中textarea中的文本
          textarea.select();
  
          // 执行复制操作
          document.execCommand('copy');
  
          // 移除临时的textarea元素
          document.body.removeChild(textarea);
  
          // 修改复制按钮文本为“已复制”
          //this.textContent = '复制成功';
          message.success('复制成功')
        });

      }



    });
  }
  const deleteConversationOk = () => {
    const sessionid = Cookies.get('sessionid')
    let data = {
      conversation_id: delConversationID.current,
      //description: newDesc.current,
      sessionid: sessionid,
      sid: sessionid,
    }
    sendHttpPostRequest('ai_chat/api/delete_conversation_by_id', data, (res) => {
      if (res.is_ok == true) {
        setDeleteConversationModalVis(false)
        queryConversationList()//删除成功后重新查询对话列表
        setIndexMode(true)//删除成功后返回到索引页面
      } else {
        message.error(res.message)
      }
    })
    delConversationID.current = ''
    delConversationName.current = ''
    
  }

  const deleteConversationCancel = () => {
    setDeleteConversationModalVis(false)
    delConversationID.current = ''
    delConversationName.current = ''
  }


  // 查询 用户的机构 ID
  const queryMyCollegeId = () => {
    sendHttpPostRequest(
      'account/api/query_teacher_authenticate',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
      },
      (response: any) => {
        if (response.is_ok == true) {
          setIsLogin(true)
          //setCourseLoaded(false)
          if (response?.college_id !== 0) {
            //已加入机构
            let _collegeId = response.college_info.college_id
            setCollegeId(_collegeId)

          } else {
            //未加入机构
            setCollegeId(0)
          }
        } 
      }
    )
  }

  // 查询 对话 列表 
  const queryConversationList = () => {
    const sessionid = Cookies.get('sessionid')
    let data = {
      page: page.current,
      pagesize: pageSize.current,
      //description: newDesc.current,
      sessionid: sessionid,
      sid: sessionid,
    }
    sendHttpPostRequest('ai_chat/api/query_conversation_list', data, (res) => {
      if (res.is_ok == true) {
        setConversationList(res?.data?.list) 
        setTotalConversationCount(res?.data?.page_info?.total_count)
        res?.data?.list?.forEach((coversationItem)=>{conversationShowMap.current.set(coversationItem.conversation_id, false)})
      } else {
        message.error(res.message)
      }
    })
  }
  //对话列表的 页码和页数发生了变化
  const onConversationPageChange = (newPage: number, newPageSize?: number | undefined) => {
    page.current = newPage ? newPage : 1
    if (newPageSize) {
      pageSize.current = newPageSize
    }
    queryConversationList()
  }

  // 查询 推荐问题 列表 
  const queryDemoQuestionList = () => {
    let id_list = []
    demoQuestions.map((demoQ, idx) => {id_list.push(demoQ.id)})
    //console.log('id_list')
    //console.log(id_list)
    const sessionid = Cookies.get('sessionid')
    let data = {
      //page: page.current,
      //pagesize: pageSize.current,
      id_list: JSON.stringify(id_list),
      //description: newDesc.current,
      sessionid: sessionid,
      sid: sessionid,
    }
    sendHttpPostRequest('ai_chat/api/query_question_list', data, (res) => {
      if (res.is_ok == true) {
        setDemoQuestions(res?.data) 
      } else {
        message.error(res.message)
      }
    })
  }
  // 新建对话, 返回对话内容, 传入名称
  const createConversation = (firstQuestionName) => {
    const sessionid = Cookies.get('sessionid')
    let data = {
      first_question: firstQuestionName,
      sessionid: sessionid,
      sid: sessionid,
    }
    sendHttpPostRequest('ai_chat/api/create_conversation', data, (res) => {
      if (res.is_ok == true) {
        queryConversationList();
        setSelectedDialogId(res.data?.conversation_id);
        //queryQAListByConversationID(res.data?.conversation_id)
        //setQuestionAnswerList([]) //新建的对话，问答列表先置空
        setSelectedDialogPage(1);  //新建对话，重置页码到 1
        page.current = 1;
        
        setIndexMode(false);

        submitQuestion(firstQuestionName, res.data?.conversation_id,true);
    
      } else {
        message.error(res.message)
      }
    })
  }

  // 置顶对话
  const setConversationTop = (conversation_id, option_) => {
    const sessionid = Cookies.get('sessionid')
    let data = {
      conversation_id: conversation_id,
      options:option_,
      sessionid: sessionid,
      sid: sessionid,
    }
    sendHttpPostRequest('ai_chat/api/set_top_conversation', data, (res) => {
      if (res.is_ok == true) {
        //置顶成功, 刷新列表
        queryConversationList()
      } else {
        message.error(res.message)
      }
    })
  }

  // 赞 或 取消赞
  const likeQuestionClick = (question_id) => {
    const sessionid = Cookies.get('sessionid')
    let data = {
      question_id: question_id,
      sessionid: sessionid,
      sid: sessionid,
    }
    sendHttpPostRequest('ai_chat/api/give_like_for_question_answer', data, (res) => {
      if (res.is_ok == true) {
        queryQAListByConversationID(selectedDialogId, false)
      } else {
        message.error(res.message)
      }
    })
  }


  // 踩  或 取消踩
  const dislikeQuestionClick = (question_id) => {
    const sessionid = Cookies.get('sessionid')
    let data = {
      question_id: question_id,
      sessionid: sessionid,
      sid: sessionid,
    }
    sendHttpPostRequest('ai_chat/api/give_dislike_for_question_answer', data, (res) => {
      if (res.is_ok == true) {
        queryQAListByConversationID(selectedDialogId, false)
      } else {
        message.error(res.message)
      }
    })
  }


  // 修改对话名称
  const updateConversation = (conversation_id, new_name) => {
    const sessionid = Cookies.get('sessionid')
    let data = {
      conversation_id: conversation_id,
      new_conversation_name: new_name,
      sessionid: sessionid,
      sid: sessionid,
    }
    sendHttpPostRequest('ai_chat/api/rename_conversation', data, (res) => {
      if (res.is_ok == true) {
        setIsConversationEditMode(false)
        queryConversationList()
      } else {
        message.error(res.msg)
      }
    })
  }


   // 查询对话的问答列表
   const queryQAListByConversationID = (conversation_id_, gotobottom=true) => {
    const sessionid = Cookies.get('sessionid')
    let data = {
      conversation_id: conversation_id_,
      page:1,
      pagesize: 1000,
      sessionid: sessionid,
      sid: sessionid,
    }
    sendHttpPostRequest('ai_chat/api/query_conversation_by_id', data, (res) => {
      if (res.is_ok == true) {
        setQuestionAnswerList(res.data?.list)
        //将引用信息进行解析保存 
        const citations_map = new Map()
        res.data?.list?.forEach((item)=>{
          item?.grouped_citations?.forEach((citation_item)=>{
            citations_map.set(item.question_id + "_" + citation_item.citation_id , citation_item.citation_text)
          })
          
        })
        questionCitationMap.current = citations_map
        //console.log(citations_map)
        if(gotobottom==true){scrollBottom()}
        setTimeout(addCopyBtnForPres, 1000)
        setTimeout(()=>{addSupCitationPopover(citations_map)}, 1000)// test TODO
      } else {
        message.error(res.msg)
      }
    })
  }

    // 查询 用户信息
    const queryUserInfo = () => {
      const sessionid = Cookies.get('sessionid')
      let data = {
        sessionid: sessionid,
        sid: sessionid,
      }
      sendHttpPostRequest('account/api/get_user_info', data, (res) => {
        if (res.is_ok == true) {
          setUserInfo(res.data)
          setMyAvatar(res.data?.avatar)
          setMyName(res.data?.nick_name)
        } else {
          message.error(res.message)
        }
      })
    }



  useEffect(() => {

    // 组件卸载时取消请求，避免内存泄漏
    if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }

    if (!checkUserLogin()) { // 如果没登录就提示登录
      sessionStorage.setItem("previousurl",window.location.href )
      document.getElementById('show-login-modal')!.click() 
    }else {
      queryMyCollegeId()//查询用户的机构ID
      console.log('getCollegeId()')
      console.log(getCollegeId())
      queryUserInfo()
      queryDemoQuestionList()
      queryConversationList()
    }




 //
  }, [])



    // 取消流式请求
  const cancelStream = () => {
    //console.log('终止请求')
    //console.log(abortControllerRef.current)
    if (abortControllerRef.current) {
      abortControllerRef.current.abort(); // 触发流终止
      //setAnswerLoading(false);
    }
  };



  /**
   * 复制问题的答案
   * @param objectId: 被复制的元素唯一标识符
   */
  const copyQuestionAnswerContent = (objectId) => {
    const copyEle = document.querySelector('#' + objectId) // 获取要复制的节点
    const range = document.createRange() // 创造range
    window.getSelection().removeAllRanges() //清除页面中已有的selection
    range.selectNode(copyEle) // 选中需要复制的节点
    window.getSelection().addRange(range) // 执行选中元素
    const copyStatus = document.execCommand('Copy') // 执行copy操作
    // 对成功与否定进行提示
    if (copyStatus) {
      message.success('复制成功')
    } else {
      message.error('复制失败')
    }
    window.getSelection().removeAllRanges() //清除页面中已有的selection
  }



  const scrollBottom = () => {
    document.getElementById('communicate_box')!.scrollTop =
      document.getElementById('communicate_box')!.scrollHeight
  }



  const fetchStream = async (t,conversation_id_) => {

      // 创建 AbortController 用于取消请求
      const abortController = new AbortController();
      abortControllerRef.current = abortController;
      
      const sessionid = Cookies.get('sessionid')

        let params = {
        conversation_id: conversation_id_,
        question: t ? t : writeQuestion,
        sessionid:sessionid,
        sid:sessionid
      }
      const _data = Qs.stringify(params)
      setAnswerLoading(true);
      setStreamData('')
      try {

        const response = await fetch(BACKEND_API_URL  + "ai_chat/api/ask_by_conversation",{
          method: 'POST',
          signal: abortController.signal,
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            //'Accept': 'text/event-stream' // 声明接收SSE格式
          },

          body:_data

        },
       
      );
        
        const stream =   response.body;
  
        if (!stream) {
          throw new Error('后端未返回有效的流式响应');
        }
        const reader = stream.getReader()
        const decoder = new TextDecoder(); // 解码二进制流为文本

        // 循环读取流数据
        let condition = true;
        while (condition) {
          const { done, value } = await reader.read();
          if (done) {
            // 流结束
            setAnswerLoading(false);
            setTimeout(addCopyBtnForPres, 1000);
            setStreamData('')
            queryQAListByConversationID(conversation_id_);
            break;
          }

          // 解码当前块数据
          const chunk = decoder.decode(value, { stream: true });
          // 按换行分割（根据后端数据格式处理）
          const lines = chunk.split('\n').filter(line => line);

          for (const line of lines){
            if (line.startsWith('data:')){
              const chunk_message =   JSON.parse(line.slice(5).trim());
              if(chunk_message.answer){
               setStreamData(prevText => prevText + chunk_message.answer);
               scrollBottom()
              }    
            }
          }
          // 更新状态（累加数据）
         
        }
      } catch (error:any) {

        // 忽略用户主动取消的错误
        if (error.name !== 'AbortError') {
          setError(error.message || '流式请求出错');
          console.log(error)
        }else{
          console.log("用户主动终止了请求");
        }
        setAnswerLoading(false);
      }
    };

  const submitQuestion = (t, conversation_id_, is_first_questions=false) => {
    if (lock) {
      return
    }
    if (!t && !writeQuestion) {
      return
    }

    setAnswerLoading(true)


    if (is_first_questions == false){
      setQuestionAnswerList(
        questionAnswerList.map((q) => {
          return {
            ...q,
            typewriter: false,
          }
        })
      )
    }

    let newQA = {
      question: t ? t : writeQuestion,
      answer: null,
      like: 0,
      dislike:0,
      create_time:'',
      grouped_citations:[],
      typewriter: true,
      conversation_id: conversation_id_,
    }

    if (is_first_questions == false){
      setQuestionAnswerList([...questionAnswerList, newQA])
    } else {
      setQuestionAnswerList([newQA])
    }

    setTimeout(()=>{scrollBottom()}, 100)

    if (requestError) {
      setRequestError(false)
    }

    fetchStream(t,conversation_id_);
  }

  const stopAnswer = (con_id) => {
    cancelStream()
    
    setTimeout(()=>{
      setAnswerLoading(false)    
      setStreamData('');
      queryQAListByConversationID(con_id)
    },1000);

  }

    
  return (

      <Layout style={{backgroundColor: '#f9fafb'}}>
        <Row wrap={false} justify={'start'} >
          <Col flex='320px' style={{background:'#fff',borderRight:'1px solid #eee',height: 'calc(100vh - 64px)',overflow: 'auto'}} >
            <div className={AICss.createDiv}>
              <span 
                className={AICss.createBtn}
               onClick={
                ()=>{
                  if (!checkUserLogin()) { // 如果没登录就提示登录
                    sessionStorage.setItem("previousurl",window.location.href )
                    document.getElementById('show-login-modal')!.click() 
                  }
                  else if(collegeId == null || collegeId == 0){
                    setIsNoCollegeModalVisible(true)
                  } else {
                    setIndexMode(true)
                  }
                
                }} > <PlusOutlined  style={{marginRight:5}}/> 新建对话</span>
            </div>


            <div className={AICss.leftContentDiv} style={{height:674}}>
              {conversationList.map((dialogue, idx) => (
                <div onClick={()=>{if(selectedDialogId !==dialogue.conversation_id)
                                  {setIsConversationEditMode(false);}
                                        
                                  setIndexMode(false);
                           
                                  setSelectedDialogId(dialogue.conversation_id);
                                  setSelectedDialogPage(page.current);
                                  queryQAListByConversationID(dialogue.conversation_id);
                                  } 
                 } key={"dialogue_" + idx} className={AICss.dialogueItem} style={{background:selectedDialogId===dialogue.conversation_id? '#f5f9f7': 'inherit', borderLeft:selectedDialogId===dialogue.conversation_id? '4px solid #07c160': 'inherit' }}>
                  <div style={{display:'inline-block', width:dialogue?.is_top == true?240:260,color:'#4b5563',fontWeight:500,overflow:'hidden', textOverflow:'ellipsis',whiteSpace:'nowrap'}}>
                     {selectedDialogId ==dialogue.conversation_id && isConversationEditMode== true ?  
                      <Input onPressEnter={(e:any)=>{updateConversation(dialogue.conversation_id, e.target.value)}}   ref={inputConversationRef} style={{ maxWidth:dialogue?.is_top == true?240:260, height:24}} defaultValue={dialogue.conversation_name}/> : <>{dialogue.conversation_name}</>  
                     }
                  </div> 
                  {dialogue?.is_top == true &&  <PushpinOutlined  style={{marginTop:4, float:'right', color:'#6b7280'}}/>}
                  <Row wrap={false}>
                    <Col span={18} style={{textAlign:'left', fontSize:12, color:'#6b7280'}}> {dialogue.create_time}</Col> 
                    <Col span={6} style={{textAlign:'right'}}> 
                      <Popover 
                        content={<div><div  onClick={()=>{conversationShowMap.current.set(dialogue.conversation_id, false);setConversationPopoverOpen(false);setConversationTop(dialogue.conversation_id, dialogue.is_top ==1?2:1)}}  className={AICss.dialogueItemAction} >  <PushpinOutlined style={{marginRight:5}} />{dialogue.is_top ==1?'取消置顶':'置顶'}</div> 
                                 <div onClick={
                                              ()=> {
                                                conversationShowMap.current.set(dialogue.conversation_id, false);
                                                setIsConversationEditMode(true);
                                                setConversationPopoverOpen(false);
                                                setTimeout(()=>{inputConversationRef?.current?.focus({cursor: 'end',})},100);
                                              }
                                            }
                                        className={AICss.dialogueItemAction}> <EditOutlined style={{marginRight:5}} />重命名</div> 
                                 <div onClick={()=>{conversationShowMap.current.set(dialogue.conversation_id, false); delConversationName.current = dialogue.conversation_name ; delConversationID.current = dialogue.conversation_id as any; setDeleteConversationModalVis(true);setConversationPopoverOpen(false);} } className={AICss.dialogueItemAction} > <DeleteOutlined  style={{marginRight:5}}/>删除</div> 
                                 </div>} 
                        title="" 
                        trigger="click"
                        placement='rightTop'
                        overlayClassName={conversationShowMap.current.get(dialogue.conversation_id) == true ? AICss.popOverDialogueOpen:  AICss.popOverDialogueClose}
                        
                       >
                          <EllipsisOutlined onClick={()=>{conversationShowMap.current.set(dialogue.conversation_id, true); setConversationPopoverOpen(true);}}  className={AICss.dialogueItemActionBtn} style={{fontSize:12, color:'#999'}} />
                      </Popover>
                    
                    </Col> 
                  </Row>
                </div>         
              ))}



            </div>

            <ConfigProvider locale={zhCN}>
            <div  style={{ margin: '15px 0', paddingTop: 30 }}
                  className={AICss.paginationWrapper} >
              <Pagination
                defaultCurrent={1}
                current={page.current}
                total={totalConversationCount}
                defaultPageSize={10}
                hideOnSinglePage={true}
                onChange={onConversationPageChange}
                showSizeChanger={false}
                size='small'
              />
            </div>
          </ConfigProvider>

          </Col>

          <Col  flex={"auto"}  style={{textAlign:'left'}}>
            <div>
              <div id="communicate_box" style={{overflow:'auto', paddingLeft:16, paddingRight:16, paddingBottom:24}}>
              <div  className={AICss.communicateBox} style={{paddingTop:indexMode == true? 140:60, paddingRight:10}}>
                {requestError ? (
                  <Alert
                    style={{
                      backgroundColor: '#FFE9D6',
                      borderRadius: '3px',
                      height: '30px',
                      padding: '8px 20px',
                      marginBottom: '10px',
                    }}
                    message="请求出现异常，请重新提问或点击重新生成"
                    banner
                  />
                ) : (
                  ''
                )}

               { indexMode == true && <div className={AICss.quickQuestion}>
                
                  <div style={{color:'#333', fontSize:24, fontWeight:'bold', marginBottom:20}}>你好，{myName}</div>
                  <div style={{marginBottom:40,fontSize:14,color:'#6b7280'}}>我是AI助手, 我将基于海量正版AI知识库, 为你解答数智专业教与学的问题，快来向我提问吧~</div>
                  <Row wrap={false} style={{fontSize:14, margin:'20px 10px'}}>
                    <Col span={12} style={{textAlign:'left',color:'#6b7280'}}> <MessageOutlined style={{color:'#07c170', marginRight:5}}/> 你可以这样问我：</Col>
                    <Col span={12} style={{textAlign:'right',color:'#07c170'}}> <div className={AICss.changeQuickQuestion} onClick={()=>{
                          if (!checkUserLogin()) { // 如果没登录就提示登录
                            sessionStorage.setItem("previousurl",window.location.href )
                            document.getElementById('show-login-modal')!.click() 
                          }else if(collegeId == null || collegeId == 0){
                            setIsNoCollegeModalVisible(true)
                          }else {
                            queryDemoQuestionList()
                          }
                      }} > <SwapOutlined  style={{color:'#07c170', marginRight:5}} /> 换一换 </div> </Col>
                  </Row>
                  <Row gutter={[16, 16]} style={{ margin: '20px 0 0 0' }}>
                    {demoQuestions.map((q, idx) => (
                      <Col key={idx} span={12} onClick={()=> {
                        if (!checkUserLogin()) { // 如果没登录就提示登录
                          sessionStorage.setItem("previousurl",window.location.href )
                          document.getElementById('show-login-modal')!.click() 
                        } else if(collegeId == null || collegeId == 0){
                          setIsNoCollegeModalVisible(true)
                        } else {
                          createConversation(q.question); 
                        }
                        
                        }}>
                        <div className={AICss.questionBox}>
                          <span style={{overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', width: '100%', display:'inline-block'}}>{q.question}</span>
          
                        </div>
                      </Col>
                    ))}
                  </Row>
                </div>
               }

                { indexMode == false &&  <div>
                    <div className={AICss.communicateArea}>
                      {questionAnswerList.map((qa, idx) => (
                        <div key={qa.question_id ? "queDiv" + qa.question_id : -1}>
                          <Row
                            align={'top'}
                            justify={'end'}
                            style={{
                              width: '100%',
                              marginBottom: '24px',
                              marginTop: '24px',
                            }}
                            wrap={false}
                          >


                            <Col flex='auto'  >

                              <div style={{float:'right'}}>
                                <div className={AICss.questionItem}>{qa.question}</div>
                              </div>
                                                           
                            </Col>

                            <Col flex="34px" style={{marginLeft:10}}>
                            
                              <img
                                className={AICss.avatar}
                                src={BACKEND_API_URL + myAvatar}
                              />
                            
                            </Col>

                          </Row>
                          <Row
                            key={qa.question_id}
                            align={'top'}
                            justify={'start'}
                            style={{
                              width: '100%',
                              position: 'relative',
                            }}
                            wrap={false}
                            className={AICss.answerContainer}
                          >
                            <Col>
                            <div className={  qa.answer == null || qa?.typewriter ?  AICss.divRobotAvatarWrapper :AICss.divRobotAvatarWrapperStatic }>
                              <div>    <img className={AICss.avatar} src={AILogo} alt="" />
                               </div>
                            </div>
                              
                            </Col>
                            <Col style={{width:'100%'}}>
                              { qa?.typewriter && streamData ? ( <>
                                <div className={AICss.answerItem} key={qa.question_id}>
                                  <ReactMarkdown
                                    remarkPlugins={[
                                      [remarkGfm, { singleTilde: false }],
                                      [remarkMath],
                                    ]}
                                    rehypePlugins={[rehypeKatex, rehypeRaw]}
                                  >
                                    {streamData}
                                  </ReactMarkdown>
                                </div>

                                {answerLoading && (
                                    <div className={AICss.stopAnswer} onClick={()=>{stopAnswer(qa.conversation_id)}}>
                                      <PauseCircleOutlined style={{ marginRight: '5px' }} /> 
                                      停止生成
                                    </div>
                                  )}

                                </>
                              ): qa?.typewriter && !streamData  ? (
                                <div className={AICss.answerItemWaitForResult}>
                                  正在为你生成答案
                                </div>
                              )  : (
                                <div id={'answer_' +qa.question_id} className={AICss.answerItem} key={qa.question_id}>
                                  <ReactMarkdown
                                    remarkPlugins={[
                                      [remarkGfm, { singleTilde: false }],
                                      [remarkMath],
                                    ]}
                                    rehypePlugins={[rehypeHighlight, rehypeKatex, rehypeRaw]}
                                  >
                                    {qa?.answer}
                                  </ReactMarkdown>
                                  <div>
                                   { qa?.grouped_citations.length > 0 &&  <div style={{color:'#999'}}> <ReadOutlined  style={{marginRight:5}} /> 参考资料 </div> }
                                    <div style={{color:'#999'}} >
                                      {qa?.grouped_citations?.map((item, idx) => (
                                         <div className={AICss.citationListItem} key={'citation_detail_'+ item.citation_id + '_' +idx}> 
                                        <Popover  key={'citations' + item.citation_id}  
                                          
                                          trigger='hover' 
                                          overlayClassName={AICss.citationPopover}
                                          content={<div> <ReactMarkdown
                                            remarkPlugins={[
                                              [remarkGfm, { singleTilde: false }],
                                              [remarkMath],
                                            ]}
                                            rehypePlugins={[rehypeKatex, rehypeRaw]}
                                          >
                                            {item.citation_text}
                                          </ReactMarkdown> </div>}
                                          
                                          >
                                            <span className={AICss.citationWrapper} >[{item.citation_id}] {' '} {item.doc_title}</span>

                                        </Popover>
                                      </div>
                                        
                                      ))}
                                    </div>
                                  </div>
                                </div>
                              )}
                              {!qa?.typewriter && (
                                <div className={AICss.answerFeedback}>
                                  <div
                                    className={AICss.btnBox}
                                    onClick={() => { likeQuestionClick(qa.question_id)}}
                                  >
                                    {qa.like == 0 ? (
                                      <LikeOutlined style={{ fontSize: '14px' }} />
                                    ) : (
                                      <LikeOutlined style={{color:'#07c160',  fontSize: '14px'}}  />
                                    )}
                                  </div>
                                  
                                  <div
                                    className={AICss.btnBox}
                                    onClick={() => { dislikeQuestionClick(qa.question_id)}}
                                  >
                                    {qa.dislike == 0 ? (
                                      <DislikeOutlined style={{ fontSize: '14px'  }} />
                                    ) : (
                                      <DislikeOutlined style={{color:'#07c160',  fontSize: '14px'}} />
                                    )}
                                  </div>

                                  
                                  <div
                                    className={AICss.btnBox}
                                    onClick={() => {copyQuestionAnswerContent('answer_' +qa.question_id)}}
                                  >
                                    <CopyOutlined  style={{ fontSize: '14px' }} />
                                  </div>

                                  
                                  <div
                                    className={AICss.btnBox}
                                    onClick={() => {submitQuestion(qa.question, selectedDialogId)}}
                                  >
                                    <ReloadOutlined  style={{ fontSize: '14px' }}  />
                                  </div>

                                </div>
                              )}

                            </Col>
                          </Row>
                        </div>
                      ))}
                    </div>
                  
                </div>
                }

              </div>
             </div>

              <div className={AICss.InputContain}>
                <div className={AICss.positionContain}>
                  <Input.TextArea
                    disabled={lock}
                    placeholder="关于AI学习，请向我提问"
                    onChange={(e) => setWriteQuestion(e.target.value)}
                    value={writeQuestion}
                    

                    /*onResize={(e) => {
                      let Heightdifference = e.height - 32
                      document.getElementById('communicate_box')!.style.height =
                        window.innerHeight - Heightdifference - 200 + 'px'
                    }}*/
                    autoSize={false}
                    className={AICss.InputStyle}
                  />
                  <div className={AICss.actionBtnContain}>
                    <div
                      className={AICss.actionBtn}
                      style={
                        writeQuestion
                          ? { marginRight: '10px' }
                          : {
                              color: '#ddd',
                              marginRight: '10px',
                              cursor: 'not-allowed',
                            }
                      }
                      onClick={()=>{
                        if (!checkUserLogin()) { // 如果没登录就提示登录
                          sessionStorage.setItem("previousurl",window.location.href )
                          document.getElementById('show-login-modal')!.click() 
                        }else if(collegeId == null || collegeId == 0){
                          setIsNoCollegeModalVisible(true)
                        }else {
                          if(answerLoading == true && indexMode == false){
                            message.error('正在回答中，请稍后再试~')
                          }else{
                            if (indexMode == true ){
                              createConversation(writeQuestion);
                              setIndexMode(false);
                              
                            }else {
                              
                              submitQuestion(writeQuestion, selectedDialogId);
                              setWriteQuestion('')
                              page.current = selectedDialogPage
                              queryConversationList();
                              scrollBottom()
                              
                            }
  
                          }
                        }

    
                      }
                      }
                    >
                      <SendOutlined className={AICss.sendBtnWrapper} style={{color:'#fff', background:'#07c160', height:26, width:26, borderRadius:'50%'}}/>
                    </div>
       
                  </div>

                </div>

                <div style={{marginTop:20, fontSize:12, textAlign:'left',  color:'#6b7280', marginLeft:'auto', marginRight:'auto', maxWidth:768}}><InfoCircleOutlined style={{marginRight:5}} />AI生成内容仅供参考，请注意辨别 </div>
              </div>
            </div>
          </Col>


        {/** 用户尚未加入院校机构, 点击了平台课程卡片的弹窗 */}
        <Modal 
            title={<div style={{ width: '100%',cursor: 'move',}}
            onMouseOver={() => {if (disabled) {setNoCollegeDisabled(false)}}}
            onMouseOut={() => {setNoCollegeDisabled(true)}}
            onFocus={() => {}}
            onBlur={() => {}}
            >
                提示</div>
            }
            width={350}
            closable={false}
            open={isNoCollegeModalVisible}
            className={courseMainStyles.miniModal}
            footer={
                <div>
                {isLogin == true && (collegeId == 0 ||  collegeId == null || collegeId == '')  &&
                    <div>
                        <Button className={courseMainStyles.stepsBtn}
                        style={{marginRight:20,color:'#07c160',  textShadow: 'none', boxShadow:'none'}}
                        onClick={()=>{setIsNoCollegeModalVisible(false)}}>取消</Button>
                        <Button className={courseMainStyles.stepsBtn}
                        style={{marginRight:20,color:'#fff', textShadow: 'none', boxShadow:'none'}}
                        type="primary"
                        onClick={()=>{window.open("/user-center")}}>填写</Button></div>
                    }
                </div>
            }
            modalRender={modal => (<div>
                <Draggable
                disabled={noCollegeDisabled}
                bounds={noCollegeBounds}
                onStart={(event, uiData) => onNoCollegeStart(event, uiData)}
                >
                <div ref={draggleNoCollegeRef}>{modal}</div>
                </Draggable> </div>
            )}
            >
                {isLogin == true && (collegeId == 0 ||  collegeId == null || collegeId == '')  &&
                  <>
                    <div style={{textAlign:'center', padding:'0 10px'}}>
                      抱歉，您还未加入院校，无法使用AI问学功能，请点击“填写”按钮，输入院校码即可查看课程 
                    </div>
                    <div style={{textAlign:'center',padding:'20px 10px 0 10px'}}>
                      开通院校机构，请联系 <span style={{color:'#07c160'}}>136 9329 0406</span>  
                    </div>
                </>
               }
        </Modal>


        </Row>
  

        {/** 删除对话弹窗 */}
        <PublicTipModal
            modalContent={<div>
            确认要删除对话{' '}<span style={{color:'#07c160'}}> {delConversationName.current}</span>{' '} 吗？
            </div>
            }
            modalTitle={'提示'}
            handleOk={deleteConversationOk}
            handleCancel={deleteConversationCancel}
            open={deleteConversationModalVis}
            setOpen={setDeleteConversationModalVis}
        />


      <Drawer
            title={'代码运行'}
            placement="right"
            //mask = {false}
            size={'large'}
            onClose={()=>{setOpenDrawer(false);resetRunningStatus();}}
            open={openDrawer}

            bodyStyle={{opacity:1}}
            destroyOnClose={true}
          >
            {test_run_output()}
          </Drawer>

        </Layout>

  );

}

export default AILearn


